import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet, apiPost } from "../utils/api_service";
import { AllowanceWiseClaimUpdateJson } from "../DynamicFormsJson/MastersJSON/allowanceWiseClaimUpdate";
const initialState = {
  claimType: [],
  claimStructure: [],
  claimApplyHeader: [],
  claimApplyHeaderNew: [],
  salesTeamClaim: [],
  claimStructureAllotment: [],
  salesTeamClaimByFlag: [],
  dashboardClaimAnalysis: [],
  allowanceWiseClaimUpdate: [],
};

let URL = endpoints.claimType;
let URL1 = endpoints.claimStructure;
let URL3 = endpoints.claimApplyHeader;
let URL4 = endpoints.claimStructureAllotment;

const claimSlice = createSlice({
  name: "claim",
  initialState,
  reducers: {
    claimTypeSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        claimType: row,
      };
    },

    claimStructureSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        claimStructure: row,
      };
    },

    claimApplyHeaderSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        claimApplyHeader: row,
      };
    },

    claimApplyHeaderSuccessNew: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        claimApplyHeaderNew: row,
      };
    },
    salesTeamClaimSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        salesTeamClaim: row,
      };
    },

    claimStructureAllotmentSuccess: (
      state = cloneDeep(initialState),
      action
    ) => {
      const { row } = action.payload;
      return {
        ...state,
        claimStructureAllotment: row,
      };
    },

    claimApplyListByFlagSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        salesTeamClaimByFlag: row,
      };
    },

    allowanceWiseClaimUpdateSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        allowanceWiseClaimUpdate: row,
      };
    },

    resetState: (state = cloneDeep(initialState), action) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const {
  claimTypeSuccess,
  claimStructureSuccess,
  claimApplyHeaderSuccess,
  claimApplyHeaderSuccessNew,
  salesTeamClaimSuccess,
  claimStructureAllotmentSuccess,
  claimApplyListByFlagSuccess,
  allowanceWiseClaimUpdateSuccess,
  resetState,
} = claimSlice.actions;

export default claimSlice.reducer;

export const getClaimType = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL,
    }).then(({ data, success }) => {
      if (success) {
        const { content } = data.data;
        const row = content.map((claimTypeObj, index) => {
          let claimTypeData = {
            index: index + 1,
            id: claimTypeObj.id === null ? "" : claimTypeObj.id,
            name: claimTypeObj.name === null ? "" : claimTypeObj.name,
            shortName:
              claimTypeObj.shortName === null ? "" : claimTypeObj.shortName,
            remark: claimTypeObj.remark === null ? "" : claimTypeObj.remark,
            limitValue:
              claimTypeObj.limitVal === null
                ? ""
                : claimTypeObj.limitVal == 1
                  ? "Yes"
                  : "No",
            limitVal:
              claimTypeObj.limitVal === null ? "" : claimTypeObj.limitVal,
            type: claimTypeObj.type === null ? "" : claimTypeObj.type,
            uomName: claimTypeObj.uomName === null ? "" : claimTypeObj.uomName,
            attachmentApplicable:
              claimTypeObj.attachmentApplicable === null
                ? ""
                : claimTypeObj.attachmentApplicable,
            extra1: claimTypeObj.extra1 === null ? "" : claimTypeObj.extra1,
            company: claimTypeObj.company === null ? "" : claimTypeObj.company,
            companyId:
              claimTypeObj.company === null ? "" : claimTypeObj.company.id,
            companyName:
              claimTypeObj.company === null ? "" : claimTypeObj.company.name,
            isActive:
              claimTypeObj.isActive === null ? "" : claimTypeObj.isActive,
            claimAmt: 0,
          };
          return claimTypeData;
        });
        dispatch(claimTypeSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getAllClaimType = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + "/get-all",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((claimTypeObj, index) => {
          let claimTypeData = {
            index: index + 1,
            id: claimTypeObj.id === null ? "" : claimTypeObj.id,
            flag: claimTypeObj.flag === null ? "" : claimTypeObj.flag,
            name: claimTypeObj.name === null ? "" : claimTypeObj.name,
            shortName:
              claimTypeObj.shortName === null ? "" : claimTypeObj.shortName,
            remark: claimTypeObj.remark === null ? "" : claimTypeObj.remark,
            limitValue:
              claimTypeObj.limitVal === null
                ? ""
                : claimTypeObj.limitVal == 1
                  ? "Yes"
                  : "No",
            limitVal:
              claimTypeObj.limitVal === null ? "" : claimTypeObj.limitVal,
            type: claimTypeObj.type === null ? "" : claimTypeObj.type,
            uomName: claimTypeObj.uomName === null ? "" : claimTypeObj.uomName,
            attachmentApplicable:
              claimTypeObj.attachmentApplicable === null
                ? ""
                : claimTypeObj.attachmentApplicable,
            extra1: claimTypeObj.extra1 === null ? "" : claimTypeObj.extra1,
            companyId:
              claimTypeObj.companyId === null ? "" : claimTypeObj.companyId,
            companyName:
              claimTypeObj.companyName === null ? "" : claimTypeObj.companyName,
            isActive:
              claimTypeObj.isActive === null ? "" : claimTypeObj.isActive,
            claimAmt: 0,
          };
          return claimTypeData;
        });
        dispatch(claimTypeSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const setClaimType =
  ({ row }) =>
    async (dispatch) => {
      dispatch(claimTypeSuccess({ row }));
    };

export const getClaimStructure = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL1,
    }).then(({ data, success }) => {
      if (success) {
        const { content } = data.data;
        const row = content.map((claimTypeObj, index) => {
          let claimTypeData = {
            index: index + 1,
            id: claimTypeObj.id === null ? "" : claimTypeObj.id,
            name: claimTypeObj.name === null ? "" : claimTypeObj.name,
            shortName:
              claimTypeObj.shortName === null ? "" : claimTypeObj.shortName,
            remark: claimTypeObj.remark === null ? "" : claimTypeObj.remark,
            extra1: claimTypeObj.extra1 === null ? "" : claimTypeObj.extra1,
            company: claimTypeObj.company === null ? "" : claimTypeObj.company,
            companyId:
              claimTypeObj.company === null ? "" : claimTypeObj.company.id,
            companyName:
              claimTypeObj.company === null ? "" : claimTypeObj.company.name,
            isActive:
              claimTypeObj.isActive === null ? "" : claimTypeObj.isActive,
          };
          return claimTypeData;
        });
        dispatch(claimStructureSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getAllClaimStructure = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL1 + "/get-all",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((claimTypeObj, index) => {
          let claimTypeData = {
            index: index + 1,
            id: claimTypeObj.id === null ? "" : claimTypeObj.id,
            companyId:
              claimTypeObj.companyId === null ? "" : claimTypeObj.companyId,
            name: claimTypeObj.name === null ? "" : claimTypeObj.name,
            type:
              claimTypeObj.fixedCalculation === null
                ? ""
                : claimTypeObj.fixedCalculation == 1
                  ? "TA / DA"
                  : "Normal",
            fixedCalculation:
              claimTypeObj.fixedCalculation === null
                ? ""
                : claimTypeObj.fixedCalculation,

            salesTeamCount:
              claimTypeObj.salesTeamCount === null
                ? ""
                : claimTypeObj.salesTeamCount,

            isActive:
              claimTypeObj.isActive === null ? "" : claimTypeObj.isActive,
          };
          return claimTypeData;
        });
        dispatch(claimStructureSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getActiveClaimStructure = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL1 + "/get-active",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((claimTypeObj, index) => {
          let claimTypeData = {
            index: index + 1,
            id: claimTypeObj.id === null ? "" : claimTypeObj.id,
            name: claimTypeObj.name === null ? "" : claimTypeObj.name,
            shortName:
              claimTypeObj.shortName === null ? "" : claimTypeObj.shortName,
            remark: claimTypeObj.remark === null ? "" : claimTypeObj.remark,
            extra1: claimTypeObj.extra1 === null ? "" : claimTypeObj.extra1,
            company: claimTypeObj.company === null ? "" : claimTypeObj.company,
            companyId:
              claimTypeObj.company === null ? "" : claimTypeObj.company.id,
            companyName:
              claimTypeObj.company === null ? "" : claimTypeObj.company.name,
          };
          return claimTypeData;
        });
        dispatch(claimStructureSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getClaimApply =
  ({ fromDate, toDate, salesTeamIds }) =>
    async (dispatch) => {
      try {
        const response = apiPost({
          url:
            URL3 +
            "/by-sales-team-and-date?fromDate=" +
            fromDate +
            "&toDate=" +
            toDate,
          postBody: salesTeamIds,
        }).then(({ data, success }) => {
          console.log(data);
          if (success) {
            const row = data.data.map((claimApplyObj, index) => {
              let claimApplyData = {
                index: index + 1,
                id: claimApplyObj.id === null ? "" : claimApplyObj.id,
                name: claimApplyObj.name === null ? "" : claimApplyObj.name,
                reportingPersonId:
                  claimApplyObj.reportingPersonId === null
                    ? ""
                    : claimApplyObj.reportingPersonId,
                reportingPersonName:
                  claimApplyObj.reportingPersonName === null
                    ? ""
                    : claimApplyObj.reportingPersonName,
                claimApplyHeader:
                  claimApplyObj.claimApplyHeader === null
                    ? ""
                    : claimApplyObj.claimApplyHeader.map(
                      (headerObj, headerIndex) => {
                        let claimApplyHeaderData = {
                          index: headerIndex + 1,
                          id: headerObj.id === null ? "" : headerObj.id,
                          claimTitle:
                            headerObj.claimTitle === null
                              ? ""
                              : headerObj.claimTitle,
                          claimAmount:
                            headerObj.claimAmount === null
                              ? ""
                              : headerObj.claimAmount,
                          status:
                            headerObj.status === null
                              ? ""
                              : headerObj.status == 0
                                ? "Pending"
                                : headerObj.status == 1
                                  ? "Cancelled"
                                  : headerObj.status == 2
                                    ? "Approved"
                                    : "Rejected",
                          date: headerObj.date === null ? "" : headerObj.date,
                          insertedUserId:
                            headerObj.insertedUserId === null
                              ? ""
                              : headerObj.insertedUserId,
                          claimApplyDetail:
                            headerObj.claimApplyDetail === null
                              ? ""
                              : headerObj.claimApplyDetail.map(
                                (detailObj, detailIndex) => {
                                  let claimApplyDetailData = {
                                    index: detailIndex + 1,
                                    id:
                                      detailObj.id === null
                                        ? ""
                                        : detailObj.id,
                                    claimApplyHeaderId:
                                      detailObj.claimApplyHeaderId === null
                                        ? ""
                                        : detailObj.claimApplyHeaderId,
                                    claimAmt:
                                      detailObj.claimAmt === null
                                        ? ""
                                        : detailObj.claimAmt,
                                    claimType:
                                      detailObj.claimType === null
                                        ? ""
                                        : detailObj.claimType,
                                    claimTypeName:
                                      detailObj.claimTypeName === null
                                        ? ""
                                        : detailObj.claimTypeName,
                                    attachFile:
                                      detailObj.attachFile === null
                                        ? ""
                                        : detailObj.attachFile,
                                    remark:
                                      detailObj.remark === null
                                        ? ""
                                        : detailObj.remark,
                                  };
                                  return claimApplyDetailData;
                                }
                              ),
                        };
                        return claimApplyHeaderData;
                      }
                    ),
              };
              return claimApplyData;
            });

            dispatch(claimApplyHeaderSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });

        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getClaim =
  ({ fromDate, toDate, type }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL3 +
            "/claim-apply-list-for-admin?fromDate=" +
            fromDate +
            "&toDate=" +
            toDate +
            "&type=" +
            type,
        }).then(({ data, success }) => {
          console.log(data);
          if (success) {
            const row = data.data.map((claimDataObj, index) => {
              let claimData = {
                index: index + 1,
                id: claimDataObj.id === null ? "" : claimDataObj.id,
                name: claimDataObj.name === null ? "" : claimDataObj.name,
                date: claimDataObj.date === null ? "" : claimDataObj.date,
                salesTeamName:
                  claimDataObj.salesTeamName !== null &&
                    claimDataObj.salesTeamTypePrefix !== null
                    ? claimDataObj.salesTeamName +
                    " (" +
                    claimDataObj.salesTeamTypePrefix +
                    ")"
                    : "",
                salesTeamTypePrefix:
                  claimDataObj.salesTeamTypePrefix === null
                    ? ""
                    : claimDataObj.salesTeamTypePrefix,

                authoritySalesPersonName:
                  claimDataObj.authoritySalesPersonName !== null &&
                    claimDataObj.authoritySalesPersonTypePrefix !== null
                    ? claimDataObj.authoritySalesPersonName +
                    " (" +
                    claimDataObj.authoritySalesPersonTypePrefix +
                    ")"
                    : "",

                authoritySalesPersonTypePrefix:
                  claimDataObj.authoritySalesPersonTypePrefix === null
                    ? ""
                    : claimDataObj.authoritySalesPersonTypePrefix,
                claimStructureHeader:
                  claimDataObj.claimStructureHeader === null
                    ? ""
                    : claimDataObj.claimStructureHeader,
                salesTeamId:
                  claimDataObj.salesTeamId === null
                    ? ""
                    : claimDataObj.salesTeamId,

                salesTeamTypeName:
                  claimDataObj.salesTeamTypeName === null
                    ? ""
                    : claimDataObj.salesTeamTypeName,

                claimType:
                  claimDataObj.claimStructureHeader !== null &&
                    claimDataObj.claimStructureHeader.fixedCalculation !== null
                    ? claimDataObj.claimStructureHeader.fixedCalculation == 0
                      ? "Regular Claim"
                      : "Allowance wise"
                    : "",
                claimAmt:
                  claimDataObj.claimAmt === null
                    ? ""
                    : claimDataObj.claimAmt.toFixed(2),
                isActive:
                  claimDataObj.isActive === null ? "" : claimDataObj.isActive,
                status:
                  claimDataObj.status === null
                    ? ""
                    : claimDataObj.status == 0
                      ? "Pending"
                      : claimDataObj.status == 1
                        ? "Cancelled"
                        : claimDataObj.status == 2
                          ? "Approved"
                          : "Rejected",
              };
              return claimData;
            });

            dispatch(claimApplyHeaderSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });

        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getClaimBalanceAndHistory =
  ({ monthYear }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url: URL3 + "/balance-and-history?monthYear=" + monthYear,
        }).then(({ data, success }) => {
          console.log(data);
          if (success) {
            const row = data.data.claimApplyHeaderList.map(
              (claimDataObjNew, index) => {
                let claimDataNew = {
                  index: index + 1,
                  id: claimDataObjNew.id === null ? "" : claimDataObjNew.id,
                  name: claimDataObjNew.name === null ? "" : claimDataObjNew.name,
                  date: claimDataObjNew.date === null ? "" : claimDataObjNew.date,
                  claimAmt:
                    ((localStorage.getItem("isTaDaClaimAmountEditable") &&
                      localStorage.getItem("isTaDaClaimAmountEditable") == 1) &&
                      (claimDataObjNew.claimStructureHeader !== null &&
                        claimDataObjNew.claimStructureHeader.fixedCalculation !== null &&
                        claimDataObjNew.claimStructureHeader.fixedCalculation == 1)) ?
                      claimDataObjNew.editedClaimAmt !== null ? claimDataObjNew.editedClaimAmt.toFixed(2) : "-" :
                      claimDataObjNew.claimAmt !== null ? claimDataObjNew.claimAmt.toFixed(2) : "-",
                  claimType:
                    claimDataObjNew.claimStructureHeader === null ||
                      claimDataObjNew.claimStructureHeader.fixedCalculation === null
                      ? ""
                      : claimDataObjNew.claimStructureHeader.fixedCalculation == 1
                        ? "TA/DA"
                        : "Regular",
                  fixedCalculation:
                    claimDataObjNew.claimStructureHeader === null ||
                      claimDataObjNew.claimStructureHeader.fixedCalculation === null
                      ? ""
                      : claimDataObjNew.claimStructureHeader.fixedCalculation,
                  noOfDays: claimDataObjNew.noOfDays === null ? "" : claimDataObjNew.noOfDays,
                  status:
                    claimDataObjNew.status === null
                      ? ""
                      : claimDataObjNew.status == 0
                        ? "Pending"
                        : claimDataObjNew.status == 1
                          ? "Cancelled"
                          : claimDataObjNew.status == 2
                            ? "Approved"
                            : "Rejected",
                  statusForTableCondition:
                    claimDataObjNew.status !== null &&
                      claimDataObjNew.claimStructureHeader !== null &&
                      claimDataObjNew.claimStructureHeader.fixedCalculation !== null
                      ? (claimDataObjNew.status == 0 && claimDataObjNew.claimStructureHeader.fixedCalculation == 0 ? 0 : 1)
                      : "",
                  salesTeam:
                    claimDataObjNew.salesTeam === null
                      ? ""
                      : claimDataObjNew.salesTeam.id,
                  isActive:
                    claimDataObjNew.isActive === null
                      ? ""
                      : claimDataObjNew.isActive,
                };
                return claimDataNew;
              }
            );

            dispatch(claimApplyHeaderSuccessNew({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });

        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getSalesTeamClaim =
  ({ monthYear }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL3 + "/claim-amts-history-by-login-person-with-extra-info?monthYear=" + monthYear,
        }).then(({ data, success }) => {
          console.log(data);
          if (success) {
            const row = data.data.claimApplyListWithExtraInfo.map((salesTeamObj, index) => {
              let salesTeamData = {
                index: index + 1,
                id: salesTeamObj.id === null ? "" : salesTeamObj.id,
                salesTeamId:
                  salesTeamObj.salesTeam !== null &&
                    salesTeamObj.salesTeam.id !== null
                    ? salesTeamObj.salesTeam.id
                    : "",
                employeeCode:
                  salesTeamObj.salesTeam !== null &&
                    salesTeamObj.salesTeam.employeeCode !== null
                    ? salesTeamObj.salesTeam.employeeCode
                    : "",
                salesTeam:
                  salesTeamObj.salesTeam !== null &&
                    salesTeamObj.salesTeam.name !== null &&
                    salesTeamObj.salesTeam.stockStakeHolderType !== null &&
                    salesTeamObj.salesTeam.stockStakeHolderType.prefix !== null
                    ? salesTeamObj.salesTeam.name +
                    " (" +
                    salesTeamObj.salesTeam.stockStakeHolderType.prefix +
                    ")"
                    : "",
                authoritySalesPersonName:
                  salesTeamObj.authoritySalesPersonName !== null &&
                    salesTeamObj.authoritySalesPersonTypePrefix !== null ?
                    salesTeamObj.authoritySalesPersonName +
                    " (" +
                    salesTeamObj.authoritySalesPersonTypePrefix +
                    ")"
                    : "",
                date: salesTeamObj.date === null ? "" : salesTeamObj.date,
                name: salesTeamObj.name === null ? "" : salesTeamObj.name,
                claimAmt:
                  ((localStorage.getItem("isTaDaClaimAmountEditable") &&
                    localStorage.getItem("isTaDaClaimAmountEditable") == 1) &&
                    (salesTeamObj.claimStructureHeader !== null &&
                      salesTeamObj.claimStructureHeader.fixedCalculation !== null &&
                      salesTeamObj.claimStructureHeader.fixedCalculation == 1)) ?
                    salesTeamObj.editedClaimAmt !== null ? salesTeamObj.editedClaimAmt.toFixed(2) : "-" :
                    salesTeamObj.claimAmt !== null ? salesTeamObj.claimAmt.toFixed(2) : "-",
                claimType:
                  salesTeamObj.claimStructureHeader === null ||
                    salesTeamObj.claimStructureHeader.fixedCalculation === null
                    ? ""
                    : salesTeamObj.claimStructureHeader.fixedCalculation == 1
                      ? "TA/DA"
                      : "Regular",
                noOfDays: salesTeamObj.noOfDays === null ? "" : salesTeamObj.noOfDays,
                status:
                  salesTeamObj.status === null
                    ? ""
                    : salesTeamObj.status == 0
                      ? "Pending"
                      : salesTeamObj.status == 1
                        ? "Cancelled"
                        : salesTeamObj.status == 2
                          ? "Approved"
                          : "Rejected",
                fixedCalculation:
                  salesTeamObj.claimStructureHeader === null ||
                    salesTeamObj.claimStructureHeader.fixedCalculation === null
                    ? ""
                    : salesTeamObj.claimStructureHeader.fixedCalculation,

                statusForCondition:
                  salesTeamObj.status === null ? "" : salesTeamObj.status,
                claimApplyDetails:
                  salesTeamObj.claimApplyDetails === null
                    ? ""
                    : salesTeamObj.claimApplyDetails,
                isActive:
                  salesTeamObj.isActive === null ? "" : salesTeamObj.isActive,
              };
              return salesTeamData;
            });

            dispatch(salesTeamClaimSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });

        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getSalesTeamClaimForFilterWithAllStatus =
  ({ monthYear }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL3 + "/all-type-claim-amts-history-by-login-person-with-extra-info?monthYear=" + monthYear,
        }).then(({ data, success }) => {
          console.log(data);
          if (success) {
            const row = data.data.claimApplyListWithExtraInfo.map((salesTeamObj, index) => {
              let salesTeamData = {
                index: index + 1,
                id: salesTeamObj.id === null ? "" : salesTeamObj.id,
                salesTeamId:
                  salesTeamObj.salesTeam !== null &&
                    salesTeamObj.salesTeam.id !== null
                    ? salesTeamObj.salesTeam.id
                    : "",
                employeeCode:
                  salesTeamObj.salesTeam !== null &&
                    salesTeamObj.salesTeam.employeeCode !== null
                    ? salesTeamObj.salesTeam.employeeCode
                    : "",
                salesTeam:
                  salesTeamObj.salesTeam !== null &&
                    salesTeamObj.salesTeam.name !== null &&
                    salesTeamObj.salesTeam.stockStakeHolderType !== null &&
                    salesTeamObj.salesTeam.stockStakeHolderType.prefix !== null
                    ? salesTeamObj.salesTeam.name +
                    " (" +
                    salesTeamObj.salesTeam.stockStakeHolderType.prefix +
                    ")"
                    : "",
                authoritySalesPersonName:
                  salesTeamObj.authoritySalesPersonName !== null &&
                    salesTeamObj.authoritySalesPersonTypePrefix !== null ?
                    salesTeamObj.authoritySalesPersonName +
                    " (" +
                    salesTeamObj.authoritySalesPersonTypePrefix +
                    ")"
                    : "",
                date: salesTeamObj.date === null ? "" : salesTeamObj.date,
                name: salesTeamObj.name === null ? "" : salesTeamObj.name,
                claimAmt:
                  ((localStorage.getItem("isTaDaClaimAmountEditable") &&
                    localStorage.getItem("isTaDaClaimAmountEditable") == 1) &&
                    (salesTeamObj.claimStructureHeader !== null &&
                      salesTeamObj.claimStructureHeader.fixedCalculation !== null &&
                      salesTeamObj.claimStructureHeader.fixedCalculation == 1)) ?
                    salesTeamObj.editedClaimAmt !== null ? salesTeamObj.editedClaimAmt.toFixed(2) : "-" :
                    salesTeamObj.claimAmt !== null ? salesTeamObj.claimAmt.toFixed(2) : "-",
                claimType:
                  salesTeamObj.claimStructureHeader === null ||
                    salesTeamObj.claimStructureHeader.fixedCalculation === null
                    ? ""
                    : salesTeamObj.claimStructureHeader.fixedCalculation == 1
                      ? "TA/DA"
                      : "Regular",
                noOfDays: salesTeamObj.noOfDays === null ? "" : salesTeamObj.noOfDays,
                status:
                  salesTeamObj.status === null
                    ? ""
                    : salesTeamObj.status == 0
                      ? "Pending"
                      : salesTeamObj.status == 1
                        ? "Cancelled"
                        : salesTeamObj.status == 2
                          ? "Approved"
                          : "Rejected",
                fixedCalculation:
                  salesTeamObj.claimStructureHeader === null ||
                    salesTeamObj.claimStructureHeader.fixedCalculation === null
                    ? ""
                    : salesTeamObj.claimStructureHeader.fixedCalculation,

                statusForCondition:
                  salesTeamObj.status === null ? "" : salesTeamObj.status,
                claimApplyDetails:
                  salesTeamObj.claimApplyDetails === null
                    ? ""
                    : salesTeamObj.claimApplyDetails,
                isActive:
                  salesTeamObj.isActive === null ? "" : salesTeamObj.isActive,
              };
              return salesTeamData;
            });

            dispatch(salesTeamClaimSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });

        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getClaimStructureAllotmentBySalesTeam =
  ({ salesTeamId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url: URL4 + "/by-sales-team?salesTeamId=" + salesTeamId,
        }).then(({ data, success }) => {
          console.log(data);
          if (success) {
            const row = data.data.map((claimObj, index) => {
              let salesTeamData = {
                index: index + 1,
                mainId: claimObj.id === null ? "" : claimObj.id,
                claimStructureHeader:
                  claimObj.claimStructureHeader !== null
                    ? claimObj.claimStructureHeader
                    : "",
                id:
                  claimObj.claimStructureHeader !== null &&
                    claimObj.claimStructureHeader.id !== null
                    ? claimObj.claimStructureHeader.id
                    : "",
                name:
                  claimObj.claimStructureHeader !== null &&
                    claimObj.claimStructureHeader.name !== null
                    ? claimObj.claimStructureHeader.name
                    : "",
                fixedCalculation:
                  claimObj.claimStructureHeader !== null &&
                    claimObj.claimStructureHeader.fixedCalculation !== null
                    ? claimObj.claimStructureHeader.fixedCalculation
                    : "",
                claimStructureDetails:
                  claimObj.claimStructureHeader !== null &&
                    claimObj.claimStructureHeader.claimStructureDetails !== null
                    ? claimObj.claimStructureHeader.claimStructureDetails
                    : [],
                fromDate: claimObj.fromDate === null ? "" : claimObj.fromDate,
                toDate: claimObj.toDate === null ? "" : claimObj.toDate,
                isActive: claimObj.isActive === null ? "" : claimObj.isActive,
              };
              return salesTeamData;
            });

            dispatch(claimStructureAllotmentSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });

        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getClaimTypeByClaimStructure =
  ({ claimStructureHeaderId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL +
            "/by-claim-structure-header?claimStructureHeaderId=" +
            claimStructureHeaderId,
        }).then(({ data, success }) => {
          if (success) {
            const row = data.data.map((claimDataObjNew, index) => {
              let claimDataNew = {
                index: index + 1,
                id: claimDataObjNew.id === null ? "" : claimDataObjNew.id,
                name: claimDataObjNew.name === null ? "" : claimDataObjNew.name,
                shortName:
                  claimDataObjNew.shortName === null
                    ? ""
                    : claimDataObjNew.shortName,
                remark:
                  claimDataObjNew.remark === null ? "" : claimDataObjNew.remark,
                remark:
                  claimDataObjNew.remark === null ? "" : claimDataObjNew.remark,
                type: claimDataObjNew.type === null ? "" : claimDataObjNew.type,
                attachmentApplicable:
                  claimDataObjNew.attachmentApplicable === null
                    ? ""
                    : claimDataObjNew.attachmentApplicable,
                isActive:
                  claimDataObjNew.isActive === null
                    ? ""
                    : claimDataObjNew.isActive,
              };
              return claimDataNew;
            });

            dispatch(claimTypeSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });

        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getClaimApplyListBySalesTeamAndFlag =
  ({ fromDate, toDate, type, salesTeamId }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL3 +
            "/claim-apply-list-by-sales-team-and-flag?fromDate=" +
            fromDate +
            "&toDate=" +
            toDate +
            "&type=" +
            type +
            "&salesTeamId=" +
            salesTeamId,
        }).then(({ data, success }) => {
          console.log(data);
          if (success) {
            const row = data.data.map((claimApplyListObj, index) => {
              let claimApplyFlagData = {
                index: index + 1,
                id: claimApplyListObj.id === null ? "" : claimApplyListObj.id,
                date:
                  claimApplyListObj.date === null ? "" : claimApplyListObj.date,
                dayName:
                  claimApplyListObj.dayName === null
                    ? ""
                    : claimApplyListObj.dayName,
                salesTeamUserName:
                  claimApplyListObj.salesTeamUserName === null
                    ? ""
                    : claimApplyListObj.salesTeamUserName,
                salesTeamEmployeeCode:
                  claimApplyListObj.salesTeamEmployeeCode === null
                    ? ""
                    : claimApplyListObj.salesTeamEmployeeCode,
                name:
                  claimApplyListObj.salesTeamName !== null &&
                    claimApplyListObj.salesTeamTypePrefix !== null
                    ? claimApplyListObj.salesTeamName +
                    " (" +
                    claimApplyListObj.salesTeamTypePrefix +
                    ")"
                    : "",
                authoritySalesPersonName:
                  claimApplyListObj.authoritySalesPersonName !== null &&
                    claimApplyListObj.authoritySalesPersonTypePrefix !== null
                    ? claimApplyListObj.authoritySalesPersonName +
                    " (" +
                    claimApplyListObj.authoritySalesPersonTypePrefix +
                    ")"
                    : "",
                salesTeamTypeName:
                  claimApplyListObj.salesTeamTypeName === null
                    ? ""
                    : claimApplyListObj.salesTeamTypeName,
                claimTitle:
                  claimApplyListObj.name === null ? "" : claimApplyListObj.name,
                claimAmt:
                  claimApplyListObj.claimAmt === null
                    ? ""
                    : claimApplyListObj.claimAmt.toFixed(2),
                status:
                  claimApplyListObj.status === null
                    ? ""
                    : claimApplyListObj.status == 0
                      ? "Pending"
                      : claimApplyListObj.status == 1
                        ? "Cancelled"
                        : claimApplyListObj.status == 2
                          ? "Approved"
                          : "Rejected",
                salesTeamId:
                  claimApplyListObj.salesTeamId === null
                    ? ""
                    : claimApplyListObj.salesTeamId,
                salesTeamName:
                  claimApplyListObj.salesTeamName === null
                    ? ""
                    : claimApplyListObj.salesTeamName,
                salesTeamTypePrefix:
                  claimApplyListObj.salesTeamTypePrefix === null
                    ? ""
                    : claimApplyListObj.salesTeamTypePrefix,
                authoritySalesPersonTypePrefix:
                  claimApplyListObj.authoritySalesPersonTypePrefix === null
                    ? ""
                    : claimApplyListObj.authoritySalesPersonTypePrefix,

                isActive:
                  claimApplyListObj.isActive === null
                    ? ""
                    : claimApplyListObj.isActive,
                insertDateTime:
                  claimApplyListObj.insertDateTime === null
                    ? ""
                    : claimApplyListObj.insertDateTime,
              };
              return claimApplyFlagData;
            });

            dispatch(claimApplyListByFlagSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });

        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };

// http://localhost:8088/api/distribution/v1/claim-apply-header/get-under-sales-team-claims?salesTeamId=6d6d698a-8710-4493-b267-c4622cc2d8c1&fromDate=10-08-2025&toDate=30-08-2025&flag=1

export const getDashboardClaimData =
  ({ fromDate, toDate, flag, salesTeamId }) =>
    async () => {
      try {
        const response = apiGet({
          url:
            URL3 +
            "/get-under-sales-team-claims?salesTeamId=" +
            salesTeamId +
            "&fromDate=" +
            fromDate +
            "&toDate=" +
            toDate +
            "&flag=" +
            flag,
        }).then(({ data, success }) => {
          console.log(data);
          if (success) {
            const row = data.data.map((claimApplyListObj, index) => {
              let claimApplyFlagData = {
                index: index + 1,
                id: claimApplyListObj.id === null ? "" : claimApplyListObj.id,
                date:
                  claimApplyListObj.date === null ? "" : claimApplyListObj.date,
                salesTeamUserName:
                  claimApplyListObj.salesTeamUserName === null
                    ? ""
                    : claimApplyListObj.salesTeamUserName,
                salesTeamEmployeeCode:
                  claimApplyListObj.salesTeamEmployeeCode === null
                    ? ""
                    : claimApplyListObj.salesTeamEmployeeCode,
                name:
                  claimApplyListObj.salesTeamName !== null &&
                    claimApplyListObj.salesTeamTypePrefix !== null
                    ? claimApplyListObj.salesTeamName
                    : "",
                authoritySalesPersonName:
                  claimApplyListObj.authoritySalesPersonName !== null &&
                    claimApplyListObj.authoritySalesPersonTypePrefix !== null
                    ? claimApplyListObj.authoritySalesPersonName
                    : "",
                salesTeamTypeName:
                  claimApplyListObj.stockStakeHolderTypeName === null
                    ? ""
                    : claimApplyListObj.stockStakeHolderTypeName,
                claimTitle:
                  claimApplyListObj.name === null ? "" : claimApplyListObj.name,
                claimTypeName:
                  claimApplyListObj.claimTypeName === null
                    ? ""
                    : claimApplyListObj.claimTypeName,
                claimAmt:
                  claimApplyListObj.claimAmt === null
                    ? ""
                    : claimApplyListObj.claimAmt.toFixed(2),
                status:
                  claimApplyListObj.status === null
                    ? ""
                    : claimApplyListObj.status == 0
                      ? "Pending"
                      : claimApplyListObj.status == 1
                        ? "Cancelled"
                        : claimApplyListObj.status == 2
                          ? "Approved"
                          : "Rejected",
                flag:
                  claimApplyListObj.status === null
                    ? ""
                    : claimApplyListObj.status,
                salesTeamId:
                  claimApplyListObj.salesTeamId === null
                    ? ""
                    : claimApplyListObj.salesTeamId,
                salesTeamName:
                  claimApplyListObj.salesTeamName === null
                    ? ""
                    : claimApplyListObj.salesTeamName,
                salesTeamTypePrefix:
                  claimApplyListObj.salesTeamTypePrefix === null
                    ? ""
                    : claimApplyListObj.salesTeamTypePrefix,
                authoritySalesPersonTypePrefix:
                  claimApplyListObj.authoritySalesPersonTypePrefix === null
                    ? ""
                    : claimApplyListObj.authoritySalesPersonTypePrefix,

                isActive:
                  claimApplyListObj.isActive === null
                    ? ""
                    : claimApplyListObj.isActive,
                insertDateTime:
                  claimApplyListObj.insertDateTime === null
                    ? ""
                    : claimApplyListObj.insertDateTime,
              };
              return claimApplyFlagData;
            });

            return { response: row, success };
          }
          return { response: [], success };
        });

        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };



export const getAllowanceWiseClaimApplyByDate =
  ({ fromDate, toDate }) =>
    async (dispatch) => {
      try {
        const response = apiGet({
          url:
            URL3 +
            "/get-day-end-claim-apply-between-dates?fromDate=" +
            fromDate + "&toDate=" + toDate,
        }).then(({ data, success }) => {
          console.log(data);
          if (success) {
            const row = data.data.map((claimApplyListObj, index) => {
              let claimApplyFlagData = {
                index: index + 1,
                id: claimApplyListObj.id === null ? "" : claimApplyListObj.id,
                date:
                  claimApplyListObj.date === null ? "" : claimApplyListObj.date,
                dayName:
                  claimApplyListObj.dayName === null ? "" : claimApplyListObj.dayName,
                salesTeamEmployeeCode:
                  claimApplyListObj.salesTeamEmployeeCode === null ? "" : claimApplyListObj.salesTeamEmployeeCode,
                salesTeamName:
                  claimApplyListObj.salesTeamName === null ? "" : claimApplyListObj.salesTeamName,
                stockStakeHolderTypeName:
                  claimApplyListObj.stockStakeHolderTypeName === null ? "" : claimApplyListObj.stockStakeHolderTypeName,
                authoritySalesPersonName:
                  claimApplyListObj.authoritySalesPersonName === null ? "" : claimApplyListObj.authoritySalesPersonName,
                authoritySalesPersonTypeName:
                  claimApplyListObj.authoritySalesPersonTypeName === null ? "" : claimApplyListObj.authoritySalesPersonTypeName,
                name:
                  claimApplyListObj.name === null ? "" : claimApplyListObj.name,
                claimAmt:
                  claimApplyListObj.claimAmt === null ? "" : claimApplyListObj.claimAmt,
                claimApplyDetail:
                  claimApplyListObj.claimApplyDetail === null ? "" : claimApplyListObj.claimApplyDetail,
                claimStatus: claimApplyListObj.claimStatus === null ? "" : claimApplyListObj.claimStatus,
                status:
                  claimApplyListObj.status === null ? "" :
                    claimApplyListObj.status == 0 ? "Pending" :
                      claimApplyListObj.status == 1 ? "Cancelled" :
                        claimApplyListObj.status == 2 ? "Approved" : "Rejected",
                isChecked: false,
              };
              return claimApplyFlagData;
            });

            dispatch(allowanceWiseClaimUpdateSuccess({ row }));
            return { response: row, success };
          }
          return { response: [], success };
        });

        return response;
      } catch (e) {
        return console.error(e.message);
      }
    };


export const setAllowanceWiseClaimApplyByDate =
  ({ row }) =>
    async (dispatch) => {
      dispatch(allowanceWiseClaimUpdateSuccess({ row }));
    };
